var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { PureComponent } from 'react';
import { string, func } from 'prop-types';
import TextElement from '../../elements/text/text';
import { emptyFunc } from 'searchband-frontend-commons/util/func';
import { TEXT_STYLE } from '../../../../data-parser/div-cards/props/text-style';
import * as CLS from './cls';

var TitleBlock = function (_PureComponent) {
    _inherits(TitleBlock, _PureComponent);

    function TitleBlock() {
        _classCallCheck(this, TitleBlock);

        return _possibleConstructorReturn(this, (TitleBlock.__proto__ || Object.getPrototypeOf(TitleBlock)).apply(this, arguments));
    }

    _createClass(TitleBlock, [{
        key: 'render',
        value: function render() {
            var props = this.props;


            return React.createElement(
                'div',
                {
                    className: CLS.block.mix(props.baseClass)(),
                    onClick: props.onClick
                },
                props.text && React.createElement(TextElement, {
                    text: props.text,
                    style: props.textStyle
                })
            );
        }
    }]);

    return TitleBlock;
}(PureComponent);

TitleBlock.defaultProps = {
    text: '',
    textStyle: TEXT_STYLE.button,
    onClick: emptyFunc
};
TitleBlock.propTypes = {
    text: string,
    textStyle: string,
    onClick: func
};
export default TitleBlock;